// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
// Container imports
const profileUserActions = require('../profile-user/actions')
const UserProfileSocialHeader = require('./component-dumb')

function mapStateToProps(state) {
  const {
    profileUser,
    profileUserStats,
    user
  } = state
  return {
    isLoggedIn: user.loggedIn,
    isSelfProfile: user.id === profileUser.id,
    profileUser,
    profileUserStats
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction, dispatchAuthRequiredAction } = deferDispatch(dispatch)
  return {
    onFollowClick: dispatchAuthRequiredAction(
      profileUserActions.toggleFollowing,
      authModalActions.showSignup
    ),
    onUserDetailsClick: dispatchAction(profileUserActions.navigateToUserProfile)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    UserProfileSocialHeader
  )
)
